import { PlanungAdminRoles, PlanungViewerRoles } from '@bp/pim-auth-constants';
import { DeputateIcon, SubstitutionsIcon, TimetableIcon, Tooltip } from '@bp/ui-components';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Permissions.module.scss';

export const Permissions = ({ permissions }: { permissions: Array<PlanungAdminRoles | PlanungViewerRoles> }) => {
  const { t } = useTranslation();

  const isAdmin = permissions.some((permission) => {
    return permission === PlanungAdminRoles.Admin;
  });

  const permissionsTooltipTranslations: Record<PlanungAdminRoles | PlanungViewerRoles, string> = useMemo(() => {
    return {
      [PlanungAdminRoles.Admin]: t('users.admin'),
      [PlanungAdminRoles.DeputatAdmin]: t('users.deputateAdmin'),
      [PlanungAdminRoles.StundenAdmin]: t('users.timetableAdmin'),
      [PlanungAdminRoles.VertretungAdmin]: t('users.substitutionAdmin'),
      [PlanungViewerRoles.DeputatViewer]: t('users.deputateViewer'),
      [PlanungViewerRoles.StundenViewer]: t('users.timetableViewer'),
      [PlanungViewerRoles.VertretungViewer]: t('users.substitutionViewer'),
      [PlanungViewerRoles.VertretungApp]: '',
    };
  }, [t]);

  return (
    <Tooltip
      content={
        <div>
          {permissions.length > 0 ? (
            isAdmin ? (
              <>{permissionsTooltipTranslations[PlanungAdminRoles.Admin]}</>
            ) : (
              permissions.map((permission, key) => (
                <div className={'mb-2'} key={`${permission}-${key}`}>
                  - {permissionsTooltipTranslations[permission]}
                </div>
              ))
            )
          ) : (
            t('users.noPermissions')
          )}
        </div>
      }
    >
      <DeputateIcon
        className={classNames(styles['svg-icon'], {
          [styles['admin']]: permissions.some(
            (p) => p === PlanungAdminRoles.Admin || p === PlanungAdminRoles.DeputatAdmin,
          ),
          [styles['viewer']]: permissions.some((p) => p === PlanungViewerRoles.DeputatViewer),
        })}
      />
      <TimetableIcon
        className={classNames(styles['svg-icon'], {
          [styles['admin']]: permissions.some(
            (p) => p === PlanungAdminRoles.Admin || p === PlanungAdminRoles.StundenAdmin,
          ),
          [styles['viewer']]: permissions.some((p) => p === PlanungViewerRoles.StundenViewer),
        })}
      />
      <SubstitutionsIcon
        className={classNames(styles['svg-icon'], {
          [styles['admin']]: permissions.some(
            (p) => p === PlanungAdminRoles.Admin || p === PlanungAdminRoles.VertretungAdmin,
          ),
          [styles['viewer']]: permissions.some((p) => p === PlanungViewerRoles.VertretungViewer),
        })}
      />
    </Tooltip>
  );
};
